var _path, _g, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_67_1655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00049 2.00024H21.9601V21.95H2.00049V2.00024Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_67_1655)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.65049 3.5C5.12949 3.5 3.50049 5.227 3.50049 7.899V16.051C3.50049 18.724 5.12949 20.45 7.65049 20.45H16.3005C18.8275 20.45 20.4605 18.724 20.4605 16.051V7.899C20.4605 5.227 18.8275 3.5 16.3005 3.5H7.65049ZM16.3005 21.95H7.65049C4.27049 21.95 2.00049 19.579 2.00049 16.051V7.899C2.00049 4.371 4.27049 2 7.65049 2H16.3005C19.6855 2 21.9605 4.371 21.9605 7.899V16.051C21.9605 19.579 19.6855 21.95 16.3005 21.95Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28126 17.1804C5.09526 17.1804 4.91026 17.1124 4.76526 16.9744C4.46426 16.6904 4.45226 16.2144 4.73726 15.9154L6.26526 14.3024C7.07426 13.4434 8.43926 13.4014 9.30226 14.2114L10.2603 15.1834C10.5273 15.4534 10.9613 15.4584 11.2293 15.1944C11.3303 15.0754 13.5083 12.4304 13.5083 12.4304C13.9223 11.9284 14.5063 11.6184 15.1553 11.5544C15.8053 11.4974 16.4363 11.6864 16.9393 12.0994C16.9823 12.1344 17.0213 12.1684 19.2173 14.4234C19.5063 14.7194 19.5013 15.1944 19.2043 15.4834C18.9083 15.7744 18.4323 15.7654 18.1433 15.4694C18.1433 15.4694 16.0943 13.3664 15.9483 13.2244C15.7933 13.0974 15.5443 13.0234 15.2993 13.0474C15.0503 13.0724 14.8263 13.1914 14.6673 13.3844C12.3433 16.2034 12.3153 16.2304 12.2773 16.2674C11.4193 17.1094 10.0343 17.0954 9.19126 16.2354C9.19126 16.2354 8.26126 15.2914 8.24526 15.2724C8.01426 15.0584 7.60226 15.0724 7.35526 15.3334L5.82526 16.9464C5.67726 17.1024 5.47926 17.1804 5.28126 17.1804Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.55769 8.12891C8.00469 8.12891 7.55469 8.57891 7.55469 9.13291C7.55469 9.68691 8.00469 10.1379 8.55869 10.1379C9.11269 10.1379 9.56369 9.68691 9.56369 9.13291C9.56369 8.57991 9.11269 8.12991 8.55769 8.12891ZM8.55869 11.6379C7.17769 11.6379 6.05469 10.5139 6.05469 9.13291C6.05469 7.75191 7.17769 6.62891 8.55869 6.62891C9.94069 6.62991 11.0637 7.75391 11.0637 9.13291C11.0637 10.5139 9.93969 11.6379 8.55869 11.6379Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.dc654518b07c82f75710b13442c381bd.svg";
export { ForwardRef as ReactComponent };